const elements = document.querySelectorAll('.fi-sidebar-item-icon');
const header = document.querySelector('.fi-sidebar-header').parentElement
const wrapper = document.createElement('div');
const sidebar = document.querySelector('.fi-sidebar-nav')
const dashboardContainer = document.getElementById('dashboard-container')
const lightLogoImg = document.querySelector('.fi-logo.dark\\:hidden');
const darkLogoImg = document.querySelector('.fi-logo.dark\\:flex');

header.remove();

sidebar.insertAdjacentHTML('afterbegin', `
<div class="flex items-center justify-center h-19.5">
        <a class="m-0 block whitespace-nowrap px-8 py-6 text-sm text-slate-700 dark:hidden" href="#" target="_blank">
            <img src="${lightLogoImg.src}" class="inline h-16 w-auto transition-all duration-200 ease-nav-brand" alt="main_logo">
        </a>
        <a class="m-0 whitespace-nowrap px-8 py-6 text-sm text-slate-700 hidden dark:block" href="#" target="_blank">
            <img src="${darkLogoImg.src}" class="inline h-16 w-auto transition-all duration-200 ease-nav-brand" alt="main_logo">
        </a>
    </div>
    <hr class="mt-0 h-px bg-transparent bg-gradient-to-r from-transparent via-black/40 dark:via-black/60 to-transparent">
    <div class="py-2"></div>
`)

elements.forEach(element => {
    const wrapper = document.createElement('div');
    wrapper.classList.add("fi-custom-theme-icon-wrapper", "py-2", "px-2", "text-sm", "ease-nav-brand", "my-0", "mx-4", "flex", "items-center", "whitespace-nowrap", "hover:bg-white", "hover:shadow-soft-3xl", "cursor-pointer", "text-slate-700", "transition-colors", "rounded-lg");
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
});


document.querySelectorAll('.fi-sidebar-item').forEach((item) => {
    item.classList.add('group')
})

